import { ReactNode } from "react";
import { Illustration, IllustrationAttributes } from "./Illustration";
import styled, { css } from "styled-components";
import { onDesktop } from "@teamscheme/theme";

export interface CardSectionProps {
  title?: ReactNode;
  ingress?: ReactNode;
  ingressClassName?: string;
  className?: string;
  children?: ReactNode;
  illustration?: IllustrationAttributes;
  illustrationPlaceholder?: ReactNode;
  largeIllustration?: boolean;
}

export const CardSectionTitle = styled.h2``;

const CardSection = styled(function ({
  title,
  ingress,
  ingressClassName,
  children,
  className,
  illustration,
  illustrationPlaceholder,
  largeIllustration = false,
}: CardSectionProps) {
  return (
    <section
      className={[
        "CardSection",
        className,
        largeIllustration ? "CardSection-large-illustration" : null,
      ]
        .filter((c) => !!c)
        .join(" ")}
    >
      {title || ingress || illustration || illustrationPlaceholder ? (
        <div className="CardSection-header">
          {illustrationPlaceholder ||
            (illustration ? (
              <Illustration illustration={illustration} />
            ) : null)}
          <CardSectionTitle>{title}</CardSectionTitle>
          {ingress && <p className={ingressClassName}>{ingress}</p>}
        </div>
      ) : null}
      {children}
    </section>
  );
})`
  .CardSection-header {
    margin-bottom: 1em;
  }

  .CardSection-header ${CardSectionTitle}:last-child {
    margin-bottom: 0;
  }

  .CardSection-header ${Illustration} {
    max-width: 100%;
    height: auto;
    width: 10em;
    display: block;
    margin: 0 auto 2em;
  }

  .CardSection-header p {
    text-align: left;
  }

  ${(props) =>
    props.largeIllustration &&
    css`
      .CardSection-header ${Illustration} {
        width: 20em;
      }
    `}
`;

export const TitleSection = styled(CardSection)`
  ${CardSectionTitle} {
    ${({ theme }) => theme.mobileFontStyle.headers.header1};
    ${({ theme }) => onDesktop`
    ${theme.fontStyle.headers.header1}
  `}
  }
`;

export default CardSection;
